import { render, staticRenderFns } from "./Beratungsauftraege.vue?vue&type=template&id=8de8a852"
import script from "./Beratungsauftraege.vue?vue&type=script&lang=js"
export * from "./Beratungsauftraege.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports